"use strict";

var _defineProperty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionStore = exports.localStore = exports.storageFactory = exports.isStorageSupported = void 0;
var ramda_1 = require("ramda");
var isStorageSupported = function isStorageSupported(storage) {
  try {
    window[storage].setItem('support_test', 'true');
    window[storage].removeItem('support_test');
    return true;
  } catch (e) {
    return false;
  }
};
exports.isStorageSupported = isStorageSupported;
var storageFactory = function storageFactory(storage) {
  var inMemoryStorage = {};
  var prefixedKey = function prefixedKey(key) {
    return "DRIFT_".concat(key);
  };
  var clear = function clear() {
    if ((0, exports.isStorageSupported)(storage)) {
      window[storage].clear();
    } else {
      inMemoryStorage = {};
    }
  };
  var key = function key(index) {
    if ((0, exports.isStorageSupported)(storage)) {
      return window[storage].key(index);
    } else {
      return Object.keys(inMemoryStorage)[index] || null;
    }
  };
  var removeItem = function removeItem(name) {
    if ((0, exports.isStorageSupported)(storage)) {
      window[storage].removeItem(prefixedKey(name));
    } else {
      delete inMemoryStorage[name];
    }
  };
  var get = function get(name) {
    if ((0, exports.isStorageSupported)(storage)) {
      var item = window[storage].getItem(prefixedKey(name));
      if (item) {
        return JSON.parse(item);
      } else {
        return item;
      }
    }
    if (inMemoryStorage.hasOwnProperty(prefixedKey(name))) {
      return inMemoryStorage[name];
    }
    return null;
  };
  var set = function set(name, value) {
    if ((0, exports.isStorageSupported)(storage)) {
      window[storage].setItem(prefixedKey(name), JSON.stringify(value));
    } else {
      inMemoryStorage[name] = value;
    }
  };
  var sadd = function sadd(name, value) {
    var existing = get(name) || [];
    set(name, (0, ramda_1.uniq)(existing.push(value)));
  };
  var srem = function srem(name, value) {
    var existing = get(prefixedKey(name)) || [];
    set(name, JSON.stringify((0, ramda_1.without)([value], existing)));
  };
  var getAll = function getAll() {
    if ((0, exports.isStorageSupported)(storage)) {
      return Object.keys(window[storage]).map(function (key) {
        return _defineProperty({}, key.split('DRIFT::')[0], window[storage].getItem(prefixedKey(key)) ? JSON.parse(
        // @ts-ignore
        window[storage].getItem(prefixedKey(key))) : window[storage].getItem(prefixedKey(key)));
      });
    } else {
      return Object.keys(inMemoryStorage).map(function (key) {
        return _defineProperty({}, key, inMemoryStorage[key]);
      });
    }
  };
  return {
    get: get,
    set: set,
    removeItem: removeItem,
    clear: clear,
    key: key,
    getAll: getAll,
    sadd: sadd,
    srem: srem
  };
};
exports.storageFactory = storageFactory;
exports.localStore = (0, exports.storageFactory)('localStorage');
exports.sessionStore = (0, exports.storageFactory)('sessionStorage');